<template>
    <div class="view-inner">
        <div v-if="isLoading" class="loading-overlay">
            <div class="spinner-border text-light" role="status"></div>
            <p>Cargando...</p>
        </div>

        <!-- Page Header -->
        <div class="page-header">
            <h1 class="page-header-title"><i class="bi bi-people"></i> Gestión de Usuarios</h1>
            <div class="page-header-actions">
                <button class="btn-add" @click="abrirModalUsuario()">
                    <i class="bi bi-plus-lg"></i> Agregar Usuario
                </button>
            </div>
        </div>

        <!-- Filtros -->
        <div class="filter-card">
            <div class="row">
                <div class="col-md-2">
                    <label class="form-label">Nombre</label>
                    <input type="text" class="form-control form-control-sm" v-model="filtros.name" placeholder="Buscar por nombre...">
                </div>
                <div class="col-md-2">
                    <label class="form-label">Email</label>
                    <input type="text" class="form-control form-control-sm" v-model="filtros.email" placeholder="Buscar por email...">
                </div>
                <div class="col-md-2">
                    <label class="form-label">DNI</label>
                    <input type="text" class="form-control form-control-sm" v-model="filtros.dni" placeholder="Buscar por DNI...">
                </div>
                <div class="col-md-2">
                    <label class="form-label">Tipo Usuario</label>
                    <select class="form-select form-select-sm" v-model="filtros.tipo_usuario">
                        <option value="">Todos</option>
                        <option value="interno">Interno</option>
                        <option value="personal">Personal</option>
                        <option value="externo">Externo</option>
                    </select>
                </div>
                <div class="col-md-2">
                    <label class="form-label">Estado</label>
                    <select class="form-select form-select-sm" v-model="filtros.estado">
                        <option value="">Todos</option>
                        <option :value="true">Activo</option>
                        <option :value="false">Inactivo</option>
                    </select>
                </div>
                <div class="col-md-2">
                    <label class="form-label">&nbsp;</label>
                    <div class="filter-actions">
                        <button class="btn-clear" @click="limpiarFiltros"><i class="bi bi-x-circle"></i> Limpiar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tabla (estándar: ESTANDAR_LISTADOS.md) -->
        <div>
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                                <th>ID</th>
                                <th>Nombre Completo</th>
                                <th>DNI</th>
                                <th>Email</th>
                                <th>Teléfono</th>
                                <th>Cargo</th>
                                <th>Tipo</th>
                                <th>Estado</th>
                                <th class="col-acciones">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="usuario in paginar(usuariosFiltrados)" :key="usuario.id">
                                <td class="celda-id">{{ usuario.id }}</td>
                                <td class="celda-entidad"><div class="entidad-nombre" :title="`${usuario.name} ${usuario.apellido || ''}`">{{ usuario.name }} {{ usuario.apellido || '' }}</div></td>
                                <td class="celda-id">{{ usuario.dni }}</td>
                                <td class="celda-entidad"><div class="entidad-nombre" :title="usuario.email">{{ usuario.email }}</div></td>
                                <td>{{ usuario.telefono || '-' }}</td>
                                <td>
                                    <span :class="getCargoBadgeClass(usuario.cargo)">
                                        {{ formatCargo(usuario.cargo) }}
                                    </span>
                                </td>
                                <td>
                                    <span :class="getTipoUsuarioBadgeClass(usuario.tipo_usuario)">
                                        {{ formatTipoUsuario(usuario.tipo_usuario) }}
                                    </span>
                                </td>
                                <td>
                                    <span :class="getEstadoBadgeClass(usuario.estado)">
                                        {{ usuario.estado ? 'Activo' : 'Inactivo' }}
                                    </span>
                                </td>
                                <td class="col-acciones">
                                    <button class="btn-icon btn-icon-view" @click="verDetalle(usuario)" title="Ver detalle" aria-label="Ver detalle">
                                        <i class="bi bi-eye"></i>
                                    </button>
                                    <button class="btn-icon btn-icon-view" @click="toggleEstado(usuario)" :title="usuario.estado ? 'Desactivar' : 'Activar'" :aria-label="usuario.estado ? 'Desactivar' : 'Activar'">
                                        <i :class="usuario.estado ? 'bi bi-toggle-on' : 'bi bi-toggle-off'"></i>
                                    </button>
                                    <button class="btn-icon btn-icon-edit" @click="editarUsuario(usuario)" title="Editar" aria-label="Editar">
                                        <i class="bi bi-pencil"></i>
                                    </button>
                                    <button class="btn-icon btn-icon-edit" @click="cambiarPassword(usuario)" title="Cambiar contraseña" aria-label="Cambiar contraseña">
                                        <i class="bi bi-key"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr v-if="!usuariosFiltrados.length" class="empty-row">
                                <td colspan="9">No se encontraron usuarios</td>
                            </tr>
                        </tbody>
                    </table>
            </div>
            <PaginacionListado :pagina="paginaActualDe(usuariosFiltrados)" :total-paginas="totalPaginasDe(usuariosFiltrados)"
                :total="usuariosFiltrados.length" :por-pagina="porPagina" :en-pagina="paginar(usuariosFiltrados).length"
                etiqueta="usuarios" @cambiar="pagina = $event" />
        </div>

        <!-- Modal para Usuario -->
        <div v-if="showModalUsuario" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ modoEdicion ? 'Editar Usuario' : 'Nuevo Usuario' }}
                        </h5>
                        <button type="button" class="btn-close" @click="cerrarModalUsuario"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="guardarUsuario">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-3">
                                        <label for="dni" class="form-label required">DNI</label>
                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            id="dni" 
                                            v-model="formUsuario.dni"
                                            :class="{ 'is-invalid': errors.dni }"
                                            placeholder="12345678"
                                            maxlength="8"
                                            required
                                        >
                                        <div v-if="errors.dni" class="invalid-feedback">
                                            {{ errors.dni }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-4">
                                    <div class="mb-3">
                                        <label for="name" class="form-label required">Nombres</label>
                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            id="name" 
                                            v-model="formUsuario.name"
                                            :class="{ 'is-invalid': errors.name }"
                                            placeholder="Nombres del usuario"
                                            maxlength="255"
                                            required
                                        >
                                        <div v-if="errors.name" class="invalid-feedback">
                                            {{ errors.name }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-4">
                                    <div class="mb-3">
                                        <label for="apellido" class="form-label">Apellidos</label>
                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            id="apellido" 
                                            v-model="formUsuario.apellido"
                                            :class="{ 'is-invalid': errors.apellido }"
                                            placeholder="Apellidos del usuario"
                                            maxlength="255"
                                        >
                                        <div v-if="errors.apellido" class="invalid-feedback">
                                            {{ errors.apellido }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="email" class="form-label required">Email</label>
                                        <input 
                                            type="email" 
                                            class="form-control" 
                                            id="email" 
                                            v-model="formUsuario.email"
                                            :class="{ 'is-invalid': errors.email }"
                                            placeholder="usuario@ejemplo.com"
                                            maxlength="255"
                                            required
                                        >
                                        <div v-if="errors.email" class="invalid-feedback">
                                            {{ errors.email }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-3">
                                    <div class="mb-3">
                                        <label for="telefono" class="form-label">Teléfono</label>
                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            id="telefono" 
                                            v-model="formUsuario.telefono"
                                            :class="{ 'is-invalid': errors.telefono }"
                                            placeholder="999888777"
                                            maxlength="15"
                                        >
                                        <div v-if="errors.telefono" class="invalid-feedback">
                                            {{ errors.telefono }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-3">
                                    <div class="mb-3">
                                        <label for="cargo" class="form-label">Cargo</label>
                                        <select 
                                            class="form-control" 
                                            id="cargo" 
                                            v-model="formUsuario.cargo"
                                            :class="{ 'is-invalid': errors.cargo }"
                                        >
                                            <option value="">Seleccione un cargo</option>
                                            <option value="admin">Admin</option>
                                            <option value="admin-draeger">Admin Draeger</option>
                                            <option value="usuario">Usuario</option>
                                            <option value="externo">Externo</option>
                                        </select>
                                        <div v-if="errors.cargo" class="invalid-feedback">
                                            {{ errors.cargo }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="tipoUsuario" class="form-label required">Tipo de Usuario</label>
                                        <select 
                                            class="form-control" 
                                            id="tipoUsuario" 
                                            v-model="formUsuario.tipo_usuario"
                                            :class="{ 'is-invalid': errors.tipo_usuario }"
                                            required
                                        >
                                            <option value="">Seleccione un tipo</option>
                                            <option value="interno">Interno</option>
                                            <option value="personal">Personal</option>
                                            <option value="externo">Externo</option>
                                        </select>
                                        <div v-if="errors.tipo_usuario" class="invalid-feedback">
                                            {{ errors.tipo_usuario }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="estado" class="form-label required">Estado</label>
                                        <select 
                                            class="form-control" 
                                            id="estado" 
                                            v-model="formUsuario.estado"
                                            :class="{ 'is-invalid': errors.estado }"
                                            required
                                        >
                                            <option :value="true">Activo</option>
                                            <option :value="false">Inactivo</option>
                                        </select>
                                        <div v-if="errors.estado" class="invalid-feedback">
                                            {{ errors.estado }}
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- Razones sociales largas: fila completa para que no se recorten -->
                                <div class="col-12">
                                    <div class="mb-3">
                                        <label for="empresa" class="form-label">Empresa</label>
                                        <select 
                                            class="form-control" 
                                            id="empresa" 
                                            v-model="formUsuario.empresa_id"
                                            :class="{ 'is-invalid': errors.empresa_id }"
                                        >
                                            <option value="">Sin empresa asignada</option>
                                            <option v-for="empresa in empresas" :key="empresa.id" :value="empresa.id">
                                                {{ empresa.razon_social || empresa.nombre }}
                                            </option>
                                        </select>
                                        <div v-if="errors.empresa_id" class="invalid-feedback">
                                            {{ errors.empresa_id }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div v-if="!modoEdicion" class="row">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="password" class="form-label required">Contraseña</label>
                                        <input 
                                            type="password" 
                                            class="form-control" 
                                            id="password" 
                                            v-model="formUsuario.password"
                                            :class="{ 'is-invalid': errors.password }"
                                            placeholder="Mínimo 8 caracteres"
                                            minlength="8"
                                            required
                                        >
                                        <div v-if="errors.password" class="invalid-feedback">
                                            {{ errors.password }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="password_confirmation" class="form-label required">Confirmar Contraseña</label>
                                        <input 
                                            type="password" 
                                            class="form-control" 
                                            id="password_confirmation" 
                                            v-model="formUsuario.password_confirmation"
                                            :class="{ 'is-invalid': errors.password_confirmation }"
                                            placeholder="Repita la contraseña"
                                            minlength="8"
                                            required
                                        >
                                        <div v-if="errors.password_confirmation" class="invalid-feedback">
                                            {{ errors.password_confirmation }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cerrarModalUsuario">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="guardarUsuario" :disabled="isLoading">
                            <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                            {{ modoEdicion ? 'Actualizar' : 'Crear Usuario' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal para Cambiar Contraseña -->
        <div v-if="showModalPassword" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Cambiar Contraseña - {{ usuarioSeleccionado?.name }}
                        </h5>
                        <button type="button" class="btn-close" @click="cerrarModalPassword"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="guardarPassword">
                            <div class="mb-3">
                                <label for="nueva_password" class="form-label required">Nueva Contraseña</label>
                                <input 
                                    type="password" 
                                    class="form-control" 
                                    id="nueva_password" 
                                    v-model="formPassword.password"
                                    :class="{ 'is-invalid': errorsPassword.password }"
                                    placeholder="Mínimo 8 caracteres"
                                    minlength="8"
                                    required
                                >
                                <div v-if="errorsPassword.password" class="invalid-feedback">
                                    {{ errorsPassword.password }}
                                </div>
                            </div>
                            
                            <div class="mb-3">
                                <label for="confirmar_password" class="form-label required">Confirmar Contraseña</label>
                                <input 
                                    type="password" 
                                    class="form-control" 
                                    id="confirmar_password" 
                                    v-model="formPassword.password_confirmation"
                                    :class="{ 'is-invalid': errorsPassword.password_confirmation }"
                                    placeholder="Repita la nueva contraseña"
                                    minlength="8"
                                    required
                                >
                                <div v-if="errorsPassword.password_confirmation" class="invalid-feedback">
                                    {{ errorsPassword.password_confirmation }}
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cerrarModalPassword">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="guardarPassword" :disabled="isLoading">
                            <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                            Cambiar Contraseña
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal para Ver Detalle -->
        <div v-if="showModalDetalle" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Detalle del Usuario - {{ usuarioSeleccionado?.name }}
                        </h5>
                        <button type="button" class="btn-close" @click="cerrarModalDetalle"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="usuarioSeleccionado">
                            <div class="col-md-6">
                                <table class="table table-bordered">
                                    <tr>
                                        <td class="fw-bold">ID:</td>
                                        <td>{{ usuarioSeleccionado.id }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">DNI:</td>
                                        <td>{{ usuarioSeleccionado.dni }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Nombres:</td>
                                        <td>{{ usuarioSeleccionado.name }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Apellidos:</td>
                                        <td>{{ usuarioSeleccionado.apellido || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Email:</td>
                                        <td>{{ usuarioSeleccionado.email }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Teléfono:</td>
                                        <td>{{ usuarioSeleccionado.telefono || '-' }}</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="col-md-6">
                                <table class="table table-bordered">
                                    <tr>
                                        <td class="fw-bold">Cargo:</td>
                                        <td>
                                            <span :class="getCargoBadgeClass(usuarioSeleccionado.cargo)">
                                                {{ formatCargo(usuarioSeleccionado.cargo) }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Tipo Usuario:</td>
                                        <td>
                                            <span :class="getTipoUsuarioBadgeClass(usuarioSeleccionado.tipo_usuario)">
                                                {{ formatTipoUsuario(usuarioSeleccionado.tipo_usuario) }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Estado:</td>
                                        <td>
                                            <span :class="getEstadoBadgeClass(usuarioSeleccionado.estado)">
                                                {{ usuarioSeleccionado.estado ? 'Activo' : 'Inactivo' }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Empresa:</td>
                                        <td>{{ usuarioSeleccionado.empresa?.razon_social || usuarioSeleccionado.empresa?.nombre || 'Sin empresa' }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Creado:</td>
                                        <td>{{ formatearFecha(usuarioSeleccionado.created_at) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Actualizado:</td>
                                        <td>{{ formatearFecha(usuarioSeleccionado.updated_at) }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cerrarModalDetalle">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import PaginacionListado from '@/components/PaginacionListado.vue'
import paginacionLocal from '@/mixins/paginacionLocal'

export default {
    name: 'GestionUsuarios',
    components: { PaginacionListado },
    mixins: [paginacionLocal],
    watch: {
        // Los filtros se aplican al escribir: cualquier cambio vuelve a la página 1
        filtros: { deep: true, handler() { this.pagina = 1 } },
    },
    data() {
        return {
            isLoading: false,
            
            // Modales
            showModalUsuario: false,
            showModalPassword: false,
            showModalDetalle: false,
            
            // Modos de edición
            modoEdicion: false,
            
            // Datos
            usuarios: [],
            empresas: [],
            usuarioSeleccionado: null,
            
            // Filtros
            filtros: {
                name: '',
                email: '',
                dni: '',
                tipo_usuario: '',
                estado: ''
            },
            
            // Formularios
            formUsuario: {
                id: null,
                dni: '',
                name: '',
                apellido: '',
                email: '',
                telefono: '',
                cargo: '',
                tipo_usuario: 'externo',
                empresa_id: '',
                estado: 1,
                password: '',
                password_confirmation: ''
            },
            formPassword: {
                password: '',
                password_confirmation: ''
            },
            
            // Errores
            errors: {},
            errorsPassword: {}
        }
    },
    computed: {
        usuariosFiltrados() {
            let filtrados = this.usuarios

            if (this.filtros.name) {
                filtrados = filtrados.filter(usuario =>
                    (usuario.name && usuario.name.toLowerCase().includes(this.filtros.name.toLowerCase())) ||
                    (usuario.apellido && usuario.apellido.toLowerCase().includes(this.filtros.name.toLowerCase()))
                )
            }

            if (this.filtros.email) {
                filtrados = filtrados.filter(usuario =>
                    usuario.email && usuario.email.toLowerCase().includes(this.filtros.email.toLowerCase())
                )
            }

            if (this.filtros.dni) {
                filtrados = filtrados.filter(usuario =>
                    usuario.dni && usuario.dni.includes(this.filtros.dni)
                )
            }

            if (this.filtros.tipo_usuario) {
                filtrados = filtrados.filter(usuario => 
                    usuario.tipo_usuario === this.filtros.tipo_usuario
                )
            }

            if (this.filtros.estado !== '') {
                filtrados = filtrados.filter(usuario => 
                    usuario.estado == this.filtros.estado
                )
            }

            return filtrados
        }
    },
    async mounted() {
        await Promise.all([
            this.cargarUsuarios(),
            this.cargarEmpresas()
        ])
    },
    methods: {
        // Formatear fecha
        formatearFecha(fecha) {
            if (!fecha) return '-'
            return new Date(fecha).toLocaleString('es-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            })
        },

        // Formatear tipo de usuario
        formatTipoUsuario(tipo) {
            const tipos = {
                'interno': 'Interno',
                'personal': 'Personal', 
                'externo': 'Externo'
            }
            return tipos[tipo] || tipo
        },

        // Formatear cargo
        formatCargo(cargo) {
            const cargos = {
                'admin': 'Admin',
                'admin-draeger': 'Admin Draeger',
                'usuario': 'Usuario',
                'externo': 'Externo'
            }
            return cargos[cargo] || cargo || '-'
        },

        getTipoUsuarioBadgeClass(tipo) {
            const clases = {
                'interno': 'badge-pill badge-interno',
                'personal': 'badge-pill badge-personal',
                'externo': 'badge-pill badge-externo'
            }
            return clases[tipo] || 'badge-pill badge-default'
        },

        getEstadoBadgeClass(estado) {
            return estado ? 'badge-pill badge-activo' : 'badge-pill badge-inactivo'
        },

        getCargoBadgeClass(cargo) {
            const clases = {
                'admin': 'badge-pill badge-admin',
                'admin-draeger': 'badge-pill badge-admin',
                'usuario': 'badge-pill badge-usuario',
                'externo': 'badge-pill badge-default'
            }
            return clases[cargo] || 'badge-pill badge-default'
        },

        // Cargar datos
        async cargarUsuarios() {
            this.isLoading = true
            try {
                const response = await axios.get('users')
                this.usuarios = response.data?.data || response.data || []
            } catch (error) {
                console.error('Error cargando usuarios:', error)
                Swal.fire('Error', 'Error al cargar los usuarios', 'error')
            } finally {
                this.isLoading = false
            }
        },

        async cargarEmpresas() {
            try {
                const response = await axios.get('empresas')
                this.empresas = response.data?.data || response.data || []
            } catch (error) {
                console.error('Error cargando empresas:', error)
            }
        },

        // Filtros (se aplican automáticamente mediante computed)
        limpiarFiltros() {
            this.filtros = {
                name: '',
                email: '',
                dni: '',
                tipo_usuario: '',
                estado: ''
            }
        },

        // Modal usuario
        abrirModalUsuario() {
            this.modoEdicion = false
            this.formUsuario = {
                id: null,
                dni: '',
                name: '',
                apellido: '',
                email: '',
                telefono: '',
                cargo: '',
                tipo_usuario: 'externo',
                empresa_id: '',
                estado: 1,
                password: '',
                password_confirmation: ''
            }
            this.errors = {}
            this.showModalUsuario = true
        },

        editarUsuario(usuario) {
            this.modoEdicion = true
            this.formUsuario = {
                id: usuario.id,
                dni: usuario.dni || '',
                name: usuario.name || '',
                apellido: usuario.apellido || '',
                email: usuario.email || '',
                telefono: usuario.telefono || '',
                cargo: usuario.cargo || '',
                tipo_usuario: usuario.tipo_usuario || 'externo',
                empresa_id: usuario.empresa_id || '',
                estado: usuario.estado
            }
            this.errors = {}
            this.showModalUsuario = true
        },

        cerrarModalUsuario() {
            this.showModalUsuario = false
            this.errors = {}
        },

        // Modal detalle
        verDetalle(usuario) {
            this.usuarioSeleccionado = usuario
            this.showModalDetalle = true
        },

        cerrarModalDetalle() {
            this.showModalDetalle = false
            this.usuarioSeleccionado = null
        },

        // Modal password
        cambiarPassword(usuario) {
            this.usuarioSeleccionado = usuario
            this.formPassword = {
                password: '',
                password_confirmation: ''
            }
            this.errorsPassword = {}
            this.showModalPassword = true
        },

        cerrarModalPassword() {
            this.showModalPassword = false
            this.usuarioSeleccionado = null
            this.errorsPassword = {}
        },

        // Validaciones
        validarFormularioUsuario() {
            this.errors = {}

            if (!this.formUsuario.dni.trim()) {
                this.errors.dni = 'El DNI es requerido'
            }

            if (!this.formUsuario.name.trim()) {
                this.errors.name = 'El nombre es requerido'
            }

            if (!this.formUsuario.email.trim()) {
                this.errors.email = 'El email es requerido'
            }

            if (!this.formUsuario.tipo_usuario) {
                this.errors.tipo_usuario = 'El tipo de usuario es requerido'
            }

            if (!this.modoEdicion) {
                if (!this.formUsuario.password.trim()) {
                    this.errors.password = 'La contraseña es requerida'
                }

                if (this.formUsuario.password !== this.formUsuario.password_confirmation) {
                    this.errors.password_confirmation = 'Las contraseñas no coinciden'
                }
            }

            return Object.keys(this.errors).length === 0
        },

        validarFormularioPassword() {
            this.errorsPassword = {}

            if (!this.formPassword.password.trim()) {
                this.errorsPassword.password = 'La nueva contraseña es requerida'
            }

            if (this.formPassword.password !== this.formPassword.password_confirmation) {
                this.errorsPassword.password_confirmation = 'Las contraseñas no coinciden'
            }

            return Object.keys(this.errorsPassword).length === 0
        },

        // Guardar
        async guardarUsuario() {
            if (!this.validarFormularioUsuario()) {
                return
            }

            this.isLoading = true
            try {
                const data = {
                    dni: this.formUsuario.dni.trim(),
                    name: this.formUsuario.name.trim(),
                    apellido: this.formUsuario.apellido?.trim() || null,
                    email: this.formUsuario.email.trim(),
                    telefono: this.formUsuario.telefono?.trim() || null,
                    cargo: this.formUsuario.cargo?.trim() || null,
                    tipo_usuario: this.formUsuario.tipo_usuario,
                    empresa_id: this.formUsuario.empresa_id || null,
                    estado: this.formUsuario.estado
                }

                if (!this.modoEdicion) {
                    data.password = this.formUsuario.password
                    data.password_confirmation = this.formUsuario.password_confirmation
                }

                if (this.modoEdicion) {
                    await axios.put(`users/${this.formUsuario.id}`, data)
                    Swal.fire('Éxito', 'Usuario actualizado correctamente', 'success')
                } else {
                    await axios.post('users', data)
                    Swal.fire('Éxito', 'Usuario creado correctamente', 'success')
                }
                
                this.cerrarModalUsuario()
                await this.cargarUsuarios()
            } catch (error) {
                console.error('Error guardando usuario:', error)
                if (error.response?.data?.errors) {
                    this.errors = error.response.data.errors
                } else {
                    Swal.fire('Error', error.response?.data?.message || 'Error al guardar el usuario', 'error')
                }
            } finally {
                this.isLoading = false
            }
        },

        async guardarPassword() {
            if (!this.validarFormularioPassword()) {
                return
            }

            this.isLoading = true
            try {
                const data = {
                    password: this.formPassword.password,
                    password_confirmation: this.formPassword.password_confirmation
                }

                await axios.put(`users/${this.usuarioSeleccionado.id}/password`, data)
                Swal.fire('Éxito', 'Contraseña actualizada correctamente', 'success')
                
                this.cerrarModalPassword()
            } catch (error) {
                console.error('Error cambiando contraseña:', error)
                if (error.response?.data?.errors) {
                    this.errorsPassword = error.response.data.errors
                } else {
                    Swal.fire('Error', error.response?.data?.message || 'Error al cambiar la contraseña', 'error')
                }
            } finally {
                this.isLoading = false
            }
        },

        // Toggle estado
        async toggleEstado(usuario) {
            const nuevoEstado = !usuario.estado
            const accion = nuevoEstado ? 'activar' : 'desactivar'

            const result = await Swal.fire({
                title: `¿Estás seguro?`,
                text: `¿Deseas ${accion} este usuario?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: nuevoEstado ? '#28a745' : '#dc3545',
                cancelButtonColor: '#6c757d',
                confirmButtonText: `Sí, ${accion}`,
                cancelButtonText: 'Cancelar'
            })

            if (result.isConfirmed) {
                this.isLoading = true
                try {
                    const data = {
                        estado: nuevoEstado ? 1 : 0
                    }
                    await axios.put(`users/${usuario.id}/change-status`, data)
                    Swal.fire('Éxito', `Usuario ${nuevoEstado ? 'activado' : 'desactivado'} correctamente`, 'success')
                    await this.cargarUsuarios()
                } catch (error) {
                    console.error('Error cambiando estado:', error)
                    Swal.fire('Error', error.response?.data?.message || 'Error al cambiar el estado', 'error')
                } finally {
                    this.isLoading = false
                }
            }
        }
    }
}
</script>

<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    color: white;
}

.modal.show {
    display: block !important;
}

/* ── Badges unificados ── */
.badge-pill {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    white-space: nowrap;
}
.badge-usuario  { background: #e8eaf6; color: #3f51b5; }
.badge-admin    { background: #ede7f6; color: #6a1b9a; }
.badge-interno  { background: #e8f5e9; color: #2e7d32; }
.badge-externo  { background: #f5f5f5; color: #546e7a; }
.badge-personal { background: #e3f2fd; color: #1565c0; }
.badge-default  { background: #f5f5f5; color: #757575; }
.badge-activo   { background: #e8f5e9; color: #2e7d32; }
.badge-inactivo { background: #ffebee; color: #c62828; }

.text-danger {
    color: #dc3545 !important;
}

.is-invalid {
    border-color: #dc3545;
}

.invalid-feedback {
    display: block;
}

.required::after {
    content: ' *';
    color: red;
}

</style>